import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PayLoadData } from 'src/Shared/model/PayLoadData';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {
  Data: string;
  payload: PayLoadData;
  isCanAprrove: boolean = false;
  isAlreadySubmitted : boolean = false;
  constructor(
    private router: Router, private route: ActivatedRoute) { }


  ngOnInit() {
    this.Data = sessionStorage.getItem('data');
    this.payload = JSON.parse(this.Data);
    if (this.payload.position >= this.payload.approvePosition) {
      this.isCanAprrove = true;
    }
    if (this.payload.is_Submited != "1") {
      this.router.navigate(['/unauthorize']);
    }else{
      if(this.payload.request =="now")
      {
        this.isAlreadySubmitted = false;
      }
      else{
        this.isAlreadySubmitted = true;
      }
    }
  }

}
